import {
  loadWorkbook,
  readSheet,
} from './index';

import Reference from '../../models/reference';
import RawSequenceData from '../../models/raw-sequence-data';
import RawAlignment from '../../models/raw-alignment';
import RawRxHistory from '../../models/raw-rx-history';

export default async function loadExcel(file, rawDataCollection) {
  const wb = await loadWorkbook(file);

  rawDataCollection.references = [loadReference(wb)];
  rawDataCollection.sequenceType = 'complete';
  rawDataCollection.rawSequences = loadSequences(wb);
  rawDataCollection.rawAlignments = loadAlignments(wb);
  rawDataCollection.rawRxHistory = loadRxHistoryList(wb);

  return rawDataCollection;
}

function loadReference(wb) {
  const ws = readSheet(wb, 'Reference');
  const referenceInfo = ws[0];
  const selected = new Reference();
  for (const [key, value] of Object.entries(referenceInfo)) {
    selected[key] = JSON.parse(value);
  }
  return selected;
}

function loadSequences(wb) {
  const ws = readSheet(wb, 'Sequence');
  const rawSequences = [];
  for (const row of ws) {
    const seq = new RawSequenceData();
    for (const [key, value] of Object.entries(row)) {
      seq[key] = JSON.parse(value);
    }
    rawSequences.push(seq);
  }
  return rawSequences;
}

function loadAlignments(wb) {
  const ws = readSheet(wb, 'Alignment');
  const rawAlignments = [];
  for (const row of ws) {
    const seq = new RawAlignment();
    for (const [key, value] of Object.entries(row)) {
      seq[key] = JSON.parse(value);
    }
    rawAlignments.push(seq);
  }
  return rawAlignments;
}

function loadRxHistoryList(wb) {
  const ws = readSheet(wb, 'RxHistory');
  const rawHistoryList = [];
  for (const row of ws) {
    const rxHistory = new RawRxHistory();
    for (const [key, value] of Object.entries(row)) {
      rxHistory[key] = JSON.parse(value);
    }
    rawHistoryList.push(rxHistory);
  }

  return rawHistoryList;
}



// WEBPACK FOOTER //
// ./src/components/workbook/load.js